import type { DealCard } from '@/app/components/search/utils/buildDealCards/dealCardTypes.ts';

export const getTripIdFromDealCard = (dealCard: DealCard): string => {
  const dealTransportId = dealCard.product?.transport?.transportId;
  if (!dealTransportId) return '';

  return dealCard.transport?.data?.find((dataItem) => dataItem.transportId === dealTransportId)?.tripId || '';
};
